import useWorkspace from '@features/Workspace/store/hooks/useWorkspace';
import { useGetDatadumpConfigQuery } from '@app-types/blackroom-api';

export interface DatadumpFolderIds {
  dataroomFolderId?: string | null;
  datadumpFolderId?: string | null;
}

function useDatadumpFolderIds(): DatadumpFolderIds {
  const workspace = useWorkspace();
  const { data } = useGetDatadumpConfigQuery({
    variables: { workspaceId: workspace.id },
  });

  return {
    dataroomFolderId: data?.datadumpConfig?.dataroomFolderId,
    datadumpFolderId: data?.datadumpConfig?.datadumpFolderId,
  };
}

export default useDatadumpFolderIds;
